/* eslint-disable no-useless-computed-key */
import { withStyles } from '@material-ui/core';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { Fragment, PureComponent } from 'react';

//import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getTestApiV2, setPageTitle, showToast } from 'modules/layout/layout.actions';
import AuthorizationsGrid from './authorizationsGrid.component';
import Log from 'utilities/log';

import { GET_AUTHORIZATIONS_FAILURE } from './store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getAuthorizationSummaries } from './store/actions/authorizations.actions';
import SendSurveyDialog from './sendSurveyDialog.component';
import { Box, Button, MenuItem, TextField } from '@mui/material';
import CreateAuthorizationDialog from './createAuthorizationDialog.component';
import { fetchEnumerations } from './utils/fetchDataDetailsService';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getInternalUsers } from 'modules/common/common.actions';

const styles = theme => ({
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100
  }
});

class AuthorizationsView extends PureComponent {
  state = {
    isDeletingRecord: false,
    sendSurveyRecord: null,
    showSendSurveyModal: false,
    showCreateAuth: false,
    filteredAuthSummaries: this.props.authorizationSummaries ? this.props.authorizationSummaries : [],
    selectedCounselorId: -1,
    selectedClientId: -1
  };

  async componentDidMount() {
    this.props.setPageTitle('Authorizations');

    await fetchEnumerations(this.props);

    if (!this.props.authorizationSummaries) {
      let { type } = await this.props.getAuthorizationSummaries();
      if (type === GET_AUTHORIZATIONS_FAILURE) {
        this.props.showToast('Failed to retrieve authorizations, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        this.setState({ filteredAuthSummaries: this.props.authorizationSummaries ? this.props.authorizationSummaries : [] });
      }
    }
  }

  handleSurveySentSuccess = async () => {
    const { selectedClientId, selectedCounselorId } = this.state;
    let { type } = await this.props.getAuthorizationSummaries();

    if (type === GET_AUTHORIZATIONS_FAILURE) {
      this.props.showToast('Failed to retrieve authorizations, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    }

    this.setState({
      showSendSurveyModal: false,
      sendSurveyRecord: null,
      filteredAuthSummaries: this.props.authorizationSummaries
        ? this.props.authorizationSummaries.filter(
            (as) =>
              (as.clientRecordId === selectedClientId || selectedClientId === -1) &&
              (as.reloCounselorInternalUserId === selectedCounselorId || selectedCounselorId === -1)
          )
        : []
    });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleSummarySelect = id => {
    this.props.history.push(`/authorizations/${id}`);
  };

  sendSurveyClicked = async record => {
    this.setState({ showSendSurveyModal: true });
    this.setState({ sendSurveyRecord: record });
  };

  render() {
    Log.trace('RENDER', 'ClientsView');
    const { history, isLoading, enumerations, unmappedClients, internalUsers } = this.props;
    const { showSendSurveyModal, sendSurveyRecord, showCreateAuth, filteredAuthSummaries, selectedClientId, selectedCounselorId } = this.state;

    const sortedClients = unmappedClients ? unmappedClients.sort((a, b) => a.shortName.localeCompare(b.shortName)) : [];
    const sortedRelocationConsultants = internalUsers ? internalUsers.filter(iu => iu.internalUserTypeId === '86edc5f8-3e50-421f-8b38-49fb77a38290').sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)) : [];

    return (
      <Fragment>
        <div className="px-2">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box sx={{ marginTop: '16px', display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ marginRight: '16px'}}>
                <TextField
                  select
                  label="Clients"
                  value={selectedClientId}
                  onChange={(event) => this.setState({ selectedClientId: event.target.value, filteredAuthSummaries: this.props.authorizationSummaries ? this.props.authorizationSummaries.filter((as) => (as.clientRecordId === event.target.value || event.target.value === -1) && (as.reloCounselorInternalUserId === selectedCounselorId || selectedCounselorId === -1)) : [] })}
                  SelectProps={{
                    autoWidth: true,
                  }}
                  variant="outlined"
                >
                  <MenuItem value={-1}>
                    <em>All Clients</em>
                  </MenuItem>
                  {sortedClients.map((option) => (
                    <MenuItem key={option.clientRecordId} value={option.clientRecordId}>
                      {option.shortName}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
              {/* TODO: Probably will need to add permission based rendering of this dropdown */}
              <TextField
                select
                label="Consultants"
                value={selectedCounselorId}
                onChange={(event) => this.setState({ selectedCounselorId: event.target.value, filteredAuthSummaries: this.props.authorizationSummaries ? this.props.authorizationSummaries.filter((as) => (as.reloCounselorInternalUserId === event.target.value || event.target.value === -1) && (as.clientRecordId === selectedClientId || selectedClientId === -1)) : [] })}
                SelectProps={{
                  autoWidth: true,
                }}
                variant="outlined"
              >
                <MenuItem value={-1}>
                  <em>All Consultants</em>
                </MenuItem>
                {sortedRelocationConsultants.map((option) => (
                  <MenuItem key={option.internalUserId} value={option.internalUserId}>
                    {option.firstName} {option.lastName}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                marginRight: '10px',
                marginTop: '8px',
                backgroundColor: '#5D9878',
                '&:hover': { backgroundColor: '#528569' }
              }}
              onClick={() => this.setState({ showCreateAuth: true })}
            >
              Create Authorization
            </Button>
          </Box>
          <AuthorizationsGrid
            authorizations={filteredAuthSummaries}
            onSelect={this.handleSummarySelect}
            isLoading={isLoading}
            history={history}
            onSendSurvey={this.sendSurveyClicked}
          />
        </div>
        {showSendSurveyModal && (
          <SendSurveyDialog
            open={true}
            onCancel={() => this.setState({ showSendSurveyModal: false, sendSurveyRecord: null })}
            authorization={sendSurveyRecord}
            onSubmit={this.handleSurveySentSuccess}
          />
        )}
        {enumerations.allEnums && enumerations.allEnums.countries && unmappedClients && (
          <CreateAuthorizationDialog
            open={showCreateAuth}
            onCancel={() => this.setState({ showCreateAuth: false })}
            history={this.props.history}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    authorizations: { authorizationSummaries, isLoading },
    enumerations,
    clients: { unmappedClients },
    common: { internalUsers }
  } = state;
  return { authorizationSummaries, isLoading, enumerations, unmappedClients, internalUsers };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    getTestApiV2,
    getAuthorizationSummaries,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getInternalUsers
  })
)(AuthorizationsView);
